import React, { useState, useEffect } from "react";

export const GraveCareChecklist = ({ checklist, onUpdate, readOnly = false }) => {
  const [localChecklist, setLocalChecklist] = useState(checklist || []);
  const [collapsed, setCollapsed] = useState(false);

  // Update local state when checklist prop changes
  useEffect(() => {
    if (checklist && checklist.length > 0) {
      setLocalChecklist(checklist);
    }
  }, [checklist]);

  const updateChecklist = (itemId, completed) => {
    const updatedChecklist = localChecklist.map(item => 
      item.id === itemId ? { ...item, completed } : item
    );
    setLocalChecklist(updatedChecklist);
    onUpdate(updatedChecklist);
  };

  const completedCount = localChecklist.filter(i => i.completed).length;

  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
      <button
        type="button"
        onClick={() => setCollapsed(!collapsed)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-100 transition-colors text-left"
      >
        <div className="flex items-center gap-2">
          <h4 className="text-sm font-semibold text-gray-800">Чек-лист выполнения</h4>
          <span className="text-xs px-2 py-0.5 rounded-full bg-white border border-gray-300 text-gray-600">
            {completedCount} / {localChecklist.length}
          </span>
        </div>
        <span className="text-xs text-gray-500">{collapsed ? "Развернуть" : "Свернуть"}</span>
      </button>
      {!collapsed && (
        <div className="px-4 pb-4 space-y-2">
          {localChecklist && localChecklist.map((item) => (
            <div key={item.id} className="flex items-start space-x-2 bg-white p-2 rounded border border-gray-100">
              <input
                type="checkbox"
                checked={item.completed || false}
                onChange={(e) => updateChecklist(item.id, e.target.checked)}
                disabled={readOnly}
                className="mt-0.5 rounded border-gray-300 text-teal-600 focus:ring-teal-500"
              />
              <span className={`text-sm ${item.completed ? 'line-through text-gray-400' : 'text-gray-700'}`}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
